import * as React from "react";
import Check from "../../static/images/check.svg";
import { Block } from "kanopi-components/Block";
import { useStyletron } from "kanopi-components/theme/useStyletron";

export function ConfirmationCircle() {
  const [, theme] = useStyletron();
  return (
    <Block
      backgroundColor={theme.colors.positive}
      borderRadius="82px"
      width="164px"
      height="164px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      marginTop="scale400"
    >
      <img src={Check} alt="Check mark in green circle" />
    </Block>
  );
}
